import {type MouseEvent} from 'react';
import {Phone, X} from 'lucide-react';
import {cn, formatCallNumber} from '@lib/utils';
import {Button} from '@ui/shadcn/button';

/**
 * Ссылка на звонок — только тег с номером и крестик «отвязать».
 * Вручную ID не вводится: звонок подтягивается из карточки звонка, поэтому без
 * привязки поле показывает только подпись.
 * Без `onOpen` (создание задачи — возвращаться ещё некуда) тег некликабельный.
 */
export const TaskCallField = ({
  value,
  canEdit,
  onChange,
  onOpen,
}: {
  value: string;
  canEdit: boolean;
  onChange: (value: string) => void;
  onOpen?: (event: MouseEvent<HTMLButtonElement>) => void;
}) => {
  if (!value)
    return (
      <p className='text-xs text-[var(--color-muted-foreground)]'>
        Звонок не привязан
      </p>
    );

  const number = formatCallNumber(value);
  const label = (
    <>
      <Phone size={12} /> <span className='truncate'>Звонок #{number}</span>
    </>
  );

  return (
    <div className='inline-flex max-w-full items-center rounded-md border border-[var(--color-primary)]/30 bg-[var(--color-primary-soft)] text-[var(--color-primary)]'>
      {onOpen ? (
        <Button
          type='button'
          variant='ghost'
          size='sm'
          onClick={onOpen}
          title={`Открыть звонок #${number}`}
          className={cn(
            'min-w-0 gap-1.5 text-xs hover:bg-[var(--color-primary)]/10 hover:text-[var(--color-primary)]',
            canEdit && 'rounded-r-none',
          )}
        >
          {label}
        </Button>
      ) : (
        <span
          title={value}
          className='inline-flex h-8 min-w-0 items-center gap-1.5 px-2.5 text-xs'
        >
          {label}
        </span>
      )}
      {canEdit && (
        <Button
          type='button'
          variant='ghost'
          size='icon-sm'
          aria-label='Удалить привязку звонка'
          title='Удалить привязку звонка'
          onClick={() => onChange('')}
          className='shrink-0 rounded-l-none hover:bg-[var(--color-primary)]/10 hover:text-[var(--color-primary)]'
        >
          <X size={13} />
        </Button>
      )}
    </div>
  );
};
